// extracted by mini-css-extract-plugin
module.exports = {"HaProxyLbDashboard":"HaProxyLbDashboard_QxXlZ"};